export default __webpack_public_path__ + "dae4ce5a4c1aa77f1f058c3daf3d2631.png";